"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CheckboxGroup = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _transform2 = _interopRequireDefault(require("lodash/transform"));

var _Field = require("../Field");

var CheckboxGroup =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(CheckboxGroup, _React$Component);

  function CheckboxGroup(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, CheckboxGroup);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(CheckboxGroup).call(this, props));
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    return _this;
  } // Receives change event from checkbox


  (0, _createClass2["default"])(CheckboxGroup, [{
    key: "onChange",
    value: function onChange(e) {
      // Remove prefix from ids
      var id = e.target.id.substring(this.props.id.length + 1);
      this.props.onChange((0, _objectSpread3["default"])({}, (0, _transform2["default"])(this.props.options, function (result, option) {
        result[option.id] = false;
      }, {}), this.props.value, (0, _defineProperty2["default"])({}, id, e.target.checked)), id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          error = _this$props.error,
          options = _this$props.options,
          onChange = _this$props.onChange,
          className = _this$props.className,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["id", "error", "options", "onChange", "className"]); // eslint-disable-line no-unused-vars

      var value = this.props.value || {};
      return _react["default"].createElement("ul", (0, _extends2["default"])({
        className: className
      }, otherProps), options.map(function (option) {
        // Add prefix for html id to avoid issues with multiple toggle groups with the same options
        var htmlId = [id, option.id].join('_');

        var label = _react["default"].createElement("label", {
          htmlFor: htmlId
        }, option.label); // Tooltip next to label


        if (option.tooltip) {
          label = _react["default"].createElement("div", {
            className: "zsg-form-label"
          }, label, option.tooltip);
        }

        return _react["default"].createElement("li", {
          key: htmlId
        }, _react["default"].createElement("input", {
          id: htmlId,
          type: "checkbox",
          checked: !!value[option.id],
          onChange: _this2.onChange,
          disabled: !!option.disabled
        }), label);
      }));
    }
  }]);
  return CheckboxGroup;
}(_react["default"].Component);

exports.CheckboxGroup = CheckboxGroup;
CheckboxGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  id: _propTypes["default"].string.isRequired,

  /**
   * Array of toggle objects with properties id and label
   */
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    label: _propTypes["default"].node,
    tooltip: _propTypes["default"].node,
    disabled: _propTypes["default"].bool
  })),

  /**
   * Object of ids -> boolean values indicating state of toggle
   */
  value: _propTypes["default"].object,
  error: _propTypes["default"].any,

  /**
   * Returns the new value after a toggle is clicked
   */
  onChange: _propTypes["default"].func,

  /**
   * Classes to add to top-level ul element
   */
  className: _propTypes["default"].string
} : {};
CheckboxGroup.displayName = 'CheckboxGroupField';
var CheckboxGroupField = (0, _Field.wrap)(CheckboxGroup);
var _default = CheckboxGroupField;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/CheckboxGroupField/index.js
// module id = 227
// module chunks = 0